const mediaItems = [
  {
    title: '独家：某顶流练习生酒店监控完整版流出',
    desc: '时长15分钟的监控录像揭示惊人细节',
    size: 'large',
    img: 'https://readdy.ai/api/search-image?query=Dark%20hotel%20corridor%20with%20security%20camera%20perspective%2C%20grainy%20surveillance%20aesthetic%2C%20dramatic%20shadows%2C%20neon%20green%20exit%20sign%20glow%2C%20mysterious%20atmosphere%2C%20high%20contrast%2C%20cinematic%20noir%20style%2C%20editorial%20quality&width=1920&height=1080&seq=media-large-01&orientation=landscape',
  },
  {
    title: '直播带货翻车现场实拍',
    desc: '产品当场被拆穿时的尴尬瞬间',
    size: 'small',
    img: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20broken%20cosmetics%20on%20dark%20table%20with%20dramatic%20lighting%2C%20neon%20green%20accent%2C%20product%20testing%20scene%2C%20editorial%20quality%2C%20high%20contrast%2C%20dark%20moody%20commercial%20style&width=800&height=600&seq=media-small-01&orientation=landscape',
  },
  {
    title: '电竞选手假赛证据截图合集',
    desc: '内部聊天记录与转账记录一一对应',
    size: 'small',
    img: 'https://readdy.ai/api/search-image?query=Smartphone%20screenshots%20of%20chat%20messages%20on%20dark%20desk%2C%20dramatic%20lighting%2C%20neon%20green%20highlights%2C%20investigative%20journalism%20aesthetic%2C%20high%20contrast%2C%20dark%20moody%20atmosphere&width=800&height=600&seq=media-small-02&orientation=landscape',
  },
  {
    title: '网红豪宅突击检查视频截图',
    desc: '虚假宣传的「豪宅」实为租借场地',
    size: 'small',
    img: 'https://readdy.ai/api/search-image?query=Empty%20luxury%20room%20with0no%20furniture%2C%20dramatic%20shadows%20from%20window%2C%20neon%20green%20exit%20sign%2C%20editorial%20photography%2C%20high%20contrast%2C%20dark%20moody%2C%20real%20estate%20deception%20theme&width=800&height=600&seq=media-small-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-20 md:py-28 bg-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-heading font-black text-foreground-50 mb-14">
          媒体现场：视频线索与截图
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {mediaItems.map((item, idx) => {
            if (item.size === 'large') {
              return (
                <div
                  key={idx}
                  className="md:col-span-2 rounded-2xl overflow-hidden relative cursor-pointer group aspect-video bg-background-300"
                >
                  <img
                    src={item.img}
                    alt={item.title}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-background-950/30 flex items-center justify-center">
                    <div className="w-14 h-14 rounded-full bg-background-50/20 backdrop-blur-sm flex items-center justify-center group-hover:bg-accent-500/30 transition-all duration-300">
                      <i className="ri-play-fill text-2xl text-foreground-50"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-950/80 to-transparent p-5">
                    <h3 className="text-base font-bold text-foreground-50 font-heading">
                      {item.title}
                    </h3>
                    <p className="text-xs text-foreground-300 mt-1">{item.desc}</p>
                  </div>
                </div>
              );
            }
            return (
              <div
                key={idx}
                className="rounded-2xl overflow-hidden relative cursor-pointer group aspect-video bg-background-300"
              >
                <img
                  src={item.img}
                  alt={item.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-background-950/30 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/20 backdrop-blur-sm flex items-center justify-center group-hover:bg-accent-500/30 transition-all duration-300">
                    <i className="ri-play-fill text-xl text-foreground-50"></i>
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-950/80 to-transparent p-4">
                  <h3 className="text-sm font-bold text-foreground-50 font-heading">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-300 mt-1">{item.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}